import type { ButtonProps } from '@_/ui';
import { useSelector } from '@tanstack/react-form';
import { FormattedMessage } from 'react-intl';
import { buttonCommonI18n } from '@_/i18n-common';
import { Button } from '@_/ui';
import { useFormContext } from './BaseForm.ts';

export function FormSubmitButton({ children, ...rest }: ButtonProps) {
  const form = useFormContext();

  const canSubmit = useSelector(form.store, state => state.canSubmit);
  const isSubmitting = useSelector(form.store, state => state.isSubmitting);
  const isSubmitSuccessful = useSelector(form.store, state => state.isSubmitSuccessful);

  const disabled = rest.disabled ?? (!canSubmit || isSubmitSuccessful);
  const loading = rest.loading ?? isSubmitting;

  return (
    <Button color="primary" {...rest} disabled={disabled} loading={loading}>
      {children || <FormattedMessage {...buttonCommonI18n.save} />}
    </Button>
  );
}
